// On phones/tablets the keyboard's Enter key adds a new line; sending is done with the button.
export const isTouchDevice = () =>
  typeof window !== "undefined" && window.matchMedia?.("(pointer: coarse)").matches;

export const enterSubmits = (e) => e.key === "Enter" && !e.shiftKey && !e.nativeEvent?.isComposing && !isTouchDevice();
